/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

import "styles/global.module.scss";

export const onRouteUpdate = ({ location, prevLocation }) => {
  if (location.pathname === '/' && prevLocation) {
    window.scrollTo(0, 0);
    window.dispatchEvent(new CustomEvent('fv-replay'));
  }
};